import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-savingsapplicationrequirements',
  templateUrl: './savingsapplicationrequirements.component.html',
  styleUrls: ['./savingsapplicationrequirements.component.css']
})
export class SavingsapplicationrequirementsComponent implements OnInit {
  @Input('product') product = {
    INVESTMENT_CATEGORY_ID: '0',
    INVESTMENT_SUB_CATEGORY_ID: '0',
    INVESTMENT_AMOUNT: '2',
    SAVINGS_PRODUCT_ID: '0',
    INVESTMENT_MAX_AMOUNT: '0',
    TENOR: '3',
    MAX_INVESTMENT_DURATION: '',
    LOAN_INTEREST: '0',
    LOAN_INTERVAL: '0',
    DURATION_INTERVAL: '0',
    LOAN_INTEREST_TYPE: '0',
    LOAN_DURATION_TYPE: '0'

  };
  @Input('loading') loading = false;
  @Output() saveMA = new EventEmitter();
  @Input('mobile') mobile =  {
    mustnotifyaccountofficer: '1',
    validate_work_email:false,
    notificationemail: '',
    checkifuserhasvalidatedbvn: false,
    checkifuserhasvalidatedemail: false,
    mustprovideselfie: false,
    jointaccount:false,
    nextofkin: false,
    education: false,
    social: false,
    homeaddress: false,
    proofofaddress: false,
    workinfo: false,
    companylist: false,
    personalexpense: false,
    financialrecords: false,
    nooffinancial: '0',
    accountcard: '0',
    guarantor: false,
    guarantorcount: '0',
    documentrefresh: '0',
    loan_product_id: '0',
    GPS_RETRY: '3',
    ENABLE_GEOTAGGING: false,
    SEND_NEW_CUSTOMER_REGISTERED: false,
    SEND_NEW_CUSTOMER_REGISTERED_EMAIL: '',
    skipphoneconfirmation:false
  }
  @Input('notify') notify :any;
  @Input('required_documents') required_documents:any;
  constructor() { }

  ngOnInit() {
  }
  saveMobileApplication(value, valid) {
    this.saveMA.emit({value:value});
  }
}
